import { Box, Button, styled, Tab, Tabs, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const MainCont = styled(Box)(({ theme }) => ({
  width: 900,
  height: '90vh',
  display: 'flex',
  flexDirection: 'column',
  padding: 30,
  alignItems: 'center',

  [theme.breakpoints.down(960)]: {
    width: 'calc(100vw - 50px)',
    height: 'calc(100% - 50px)',
    padding: 10,
  },
}));

export const BinHeader = styled(Typography)(() => ({
  fontSize: 24,
  fontWeight: 600,
}));

export const SelectedContent = styled(Box)(() => ({
  color: '#3a81eb',
  fontSize: 16,
  fontWeight: 500,
}));

export const AddButton = styled(Button)(({ theme }) => ({
  width: 258,
  height: 44,
  backgroundColor: '#3e8bff',
  marginTop: 'auto',

  [theme.breakpoints.down(960)]: {
    marginTop: 20,
  },
}));

export const TabHeader = styled(Tabs)(({ theme }) => ({
  minHeight: 50,
  '& .MuiTab-root': {
    minWidth: 'unset',
  },
  '& .PrivateTabIndicator-colorSecondary-2381': {
    backgroundColor: 'none',
  },
  '& .MuiTabs-flexContainer': {
    [theme.breakpoints.down(960)]: {
      justifyContent: 'center',
    },
  },
}));

export const TabItem = styled(Tab)(({ theme }) => ({
  opacity: 1,
  '&.Mui-selected': {
    color: COLORS.PRIMARY,
  },
}));

export const ActiveTabContainer = styled(Box)(() => ({
  flex: 1,
  width: '100%',
  overflow: 'auto',
  marginTop: 10,
}));

export const TabContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  height: '82%',
}));

export const NoMediaCont = styled(Box)(() => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'rgb(147, 161, 182)',
  paddingBottom: 100,
  fontSize: 18,
}));

export const SectionCont = styled(Box)(() => ({
  overflow: 'auto',
  width: '100%',
}));
